import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Flex } from "theme-ui";
import { themevals } from "theme/themevals";

/**
 * The one-line summary tile that links to Reports (spec section 1).
 *
 * DELIBERATELY NOT A METRIC. The temptation is to put a headline number
 * here - conversion rate, expiring value - and the moment that happens
 * the dashboard has started accumulating depth again, which is the
 * exact failure the Reports split exists to prevent. It says what lives
 * there and gets out of the way.
 */
const ReportsTile: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Flex
      onClick={() => navigate("/reports")}
      sx={{
        alignItems: "center",
        justifyContent: "space-between",
        gap: "12px",
        padding: "16px",
        marginBottom: "24px",
        cursor: "pointer",
        backgroundColor: "#FFFFFF",
        borderRadius: "6px",
        border: "1px solid",
        borderColor: themevals.colors.inputOutline,
        boxShadow: "0px 0px 12px 4px rgba(129, 129, 129, 0.07)",
        ":hover": { backgroundColor: "#F7F9FC" },
      }}
    >
      <Box>
        <Box
          sx={{
            fontFamily: "Poppins, sans-serif",
            fontSize: "14px",
            fontWeight: 600,
            color: "black",
          }}
        >
          Reports
        </Box>
        <Box
          sx={{
            fontFamily: "Poppins, sans-serif",
            fontSize: "12px",
            color: themevals.colors.dkgrey,
            marginTop: "2px",
          }}
        >
          Pipeline health, expiration intelligence, deposits, price locks and
          activity history.
        </Box>
      </Box>
      <Box
        sx={{
          fontFamily: "Poppins, sans-serif",
          fontSize: "12px",
          fontWeight: 500,
          padding: "6px 12px",
          borderRadius: "6px",
          border: "1px solid",
          borderColor: themevals.colors.inputOutline,
          color: themevals.colors.base_800,
          flexShrink: 0,
        }}
      >
        Open reports
      </Box>
    </Flex>
  );
};

export default ReportsTile;
